import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import router from './router.js'
import store from './store'
import Loading from 'vue-loading-overlay'
import { firebaseListener, domain, firebaseAnalytics } from './config/firebaseConfig'
import AllIosIcon from 'vue-ionicons/dist/ionicons-ios.js'

import './assets/styles/app.scss'

import App from './App.vue'
import './filters.js'
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.use(VueMeta)
Vue.use(AllIosIcon)
Vue.use(Loading)
Vue.use(VueRouter)

firebaseListener(authStatusChange)
require('../node_modules/vue-loading-overlay/dist/vue-loading.css')
require('vue-ionicons/ionicons.css')
require('./assets/styles/style.css')

Vue.prototype.$analytics = firebaseAnalytics

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')

function authStatusChange (loggedIn, user) {
  if (store) {
    store.commit('AUTH_STATUS_CHANGE')
    if (domain) {
      console.log('seeting', domain)
      store.dispatch('setShopId', domain)
    }
    if (user) {
      store.dispatch('getUserDetails')
    }
  }
}
